module.exports = __webpack_public_path__ + "img/playlist-add.75c861c6.svg";